import React from 'react';
import styles from './Hero.module.css';
import { Container } from '../../common/Container';
import { Button } from '../../common/Button';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import clsx from 'clsx';

interface HeroProps {
  onNavigate?: (sectionId: string) => void;
}

export const Hero: React.FC<HeroProps> = ({ onNavigate }) => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  const handleViewPortfolio = () => {
    if (onNavigate) {
      onNavigate('portfolio');
    }
  };

  const handleContact = () => {
    if (onNavigate) {
      onNavigate('contact');
    }
  };

  return (
    <section id="hero" className={styles.hero} ref={ref}>
      <Container>
        <div className={clsx(styles.heroContent, isVisible && styles.visible)}>
          <h1 className={styles.heading}>
            I build
            <br />
            <span className={styles.highlight}>iOS apps.</span>
          </h1>

          <p className={styles.tagline}>
            Indie developer. I design, build, and ship apps from concept to App Store —
            Compass and Tide Post are live.
          </p>

          <div className={styles.ctaButtons}>
            <Button
              variant="primary"
              size="lg"
              onClick={handleViewPortfolio}
            >
              See the Apps
            </Button>
            <Button
              variant="outline-inverse"
              size="lg"
              onClick={handleContact}
            >
              Get In Touch
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};
